"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FuturesFormAmountFields = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _FormItem = require("../../form/FormItem");
var _NumberInput = require("../../form/NumberInput");
var _APReactSelect = _interopRequireDefault(require("../../common/APReactSelect/APReactSelect"));
var _Button = require("../../form/Button/Button");
var _Slider = require("../../common/Slider/Slider");
var _useValidators2 = require("../../../constants/useValidators");
var _useFuturesMoneyFields = require("../hooks/useFuturesMoneyFields");
var _StrategiesSelection = require("../common/StrategiesSelection/StrategiesSelection");
var _orderEntryFormConstants = require("../../../constants/sendOrder/orderEntryFormConstants");
var _selectors = require("../../../redux/futures/selectors");
var _FuturesOrderEntryFormContainer = require("./FuturesOrderEntryForm/FuturesOrderEntryFormContainer");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var breakpoints = [0, 25, 50, 75, 100];
var LastPriceButton = function LastPriceButton(_ref) {
  var _onClick = _ref.onClick,
    disabled = _ref.disabled;
  var _useTranslation = (0, _reactI18next.useTranslation)('order'),
    t = _useTranslation.t;
  var lastPrice = (0, _reactRedux.useSelector)(_selectors.futuresLastPriceSelector);
  return /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    type: "button",
    size: "xs",
    variant: "link-color",
    onClick: function onClick() {
      return _onClick(lastPrice);
    },
    disabled: disabled
  }, t('Last'));
};
var FuturesFormAmountFields = exports.FuturesFormAmountFields = function FuturesFormAmountFields(_ref2) {
  var baseClass = _ref2.baseClass,
    futuresOrderEntryClasses = _ref2.futuresOrderEntryClasses,
    maxQuantity = _ref2.maxQuantity,
    fieldLayout = _ref2.fieldLayout;
  var _useTranslation2 = (0, _reactI18next.useTranslation)('order'),
    t = _useTranslation2.t;
  var _useValidators = (0, _useValidators2.useValidators)(),
    greaterThanZero = _useValidators.greaterThanZero,
    optionalGreaterThanZero = _useValidators.optionalGreaterThanZero,
    futuresGreaterThanOrEqualToValue = _useValidators.futuresGreaterThanOrEqualToValue,
    futuresP1MinimumAmountValidator = _useValidators.futuresP1MinimumAmountValidator;
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useFuturesMoneyField = (0, _useFuturesMoneyFields.useFuturesMoneyFields)(maxQuantity),
    formValues = _useFuturesMoneyField.formValues,
    sliderValue = _useFuturesMoneyField.sliderValue,
    maxAmount = _useFuturesMoneyField.maxAmount,
    onSliderChange = _useFuturesMoneyField.onSliderChange,
    valueDP = _useFuturesMoneyField.valueDP,
    quantityDP = _useFuturesMoneyField.quantityDP,
    _useFuturesMoneyField2 = _useFuturesMoneyField.instrument,
    Product1Symbol = _useFuturesMoneyField2.Product1Symbol,
    Product2Symbol = _useFuturesMoneyField2.Product2Symbol,
    onChange = _useFuturesMoneyField.onChange,
    isDisabled = _useFuturesMoneyField.isDisabled,
    isConditionalPricefieldDisabled = _useFuturesMoneyField.isConditionalPricefieldDisabled,
    estimatedProfitValue = _useFuturesMoneyField.estimatedProfitValue,
    estimatedLossValue = _useFuturesMoneyField.estimatedLossValue,
    minimumQuantity = _useFuturesMoneyField.minimumQuantity;
  var value = formValues.value,
    orderByProduct = formValues.orderByProduct,
    orderType = formValues.orderType,
    TPSL = formValues.TPSL;
  var priceTypeOptions = [{
    value: 'LastPrice',
    label: t('Last')
  }, {
    value: 'MarkPrice',
    label: t('Mark')
  }, {
    value: 'IndexPrice',
    label: t('Index')
  }];
  var validateMaxQuantity = (0, _react.useCallback)(function (value) {
    var side = formValues.side == 0 ? 'Buy' : 'Sell';
    return value > maxAmount ? t("".concat(side, " Amount exceeds the Max ").concat(side, " Amount. Please verify and try again.")) : undefined;
  }, [maxAmount, formValues.side, t]);
  var handleOrderByProductChange = function handleOrderByProductChange(value) {
    dispatch((0, _reduxForm.change)(_FuturesOrderEntryFormContainer.FUTURES_ORDER_FORM_NAME, 'orderByProduct', value));
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, orderType === _orderEntryFormConstants.futuresOrderTypes.limit.displayName && /*#__PURE__*/_react["default"].createElement(_FormItem.RFormInputItem, {
    component: _NumberInput.MoneyInputWithSlots,
    suffix: /*#__PURE__*/_react["default"].createElement(LastPriceButton, {
      onClick: function onClick(lastPrice) {
        return onChange('limitPrice', lastPrice);
      }
    }),
    size: "small",
    name: "limitPrice",
    placeholder: "0",
    className: baseClass,
    label: t('Limit Price'),
    symbol: Product2Symbol !== null && Product2Symbol !== void 0 ? Product2Symbol : '',
    validate: [greaterThanZero],
    decimalPlaces: valueDP,
    layout: fieldLayout
    //onFocus={() => onChange('anchoredField', 'limitPrice')}
  }), orderType === _orderEntryFormConstants.futuresOrderTypes.conditional.displayName && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_FormItem.RFormInputItem, {
    component: _NumberInput.MoneyInputWithSlots,
    suffix: /*#__PURE__*/_react["default"].createElement(_APReactSelect["default"], {
      name: "triggerPriceType",
      customClass: "suffix-select",
      isSearchable: false,
      valueAsObject: false,
      options: priceTypeOptions
    }),
    size: "small",
    name: "triggerPrice",
    placeholder: "0",
    className: baseClass,
    label: t('Trigger Price'),
    symbol: Product2Symbol !== null && Product2Symbol !== void 0 ? Product2Symbol : '',
    validate: [greaterThanZero],
    decimalPlaces: valueDP,
    layout: fieldLayout
    //onFocus={() => onChange('anchoredField', 'limitPrice')}
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: futuresOrderEntryClasses('price-row-wrapper')
  }, /*#__PURE__*/_react["default"].createElement(_FormItem.RFormInputItem, {
    component: _NumberInput.MoneyInputWithSlots,
    suffix: /*#__PURE__*/_react["default"].createElement(LastPriceButton, {
      onClick: function onClick(lastPrice) {
        return onChange('price', lastPrice);
      },
      disabled: isConditionalPricefieldDisabled
    }),
    size: "small",
    name: "price",
    placeholder: "0",
    className: baseClass,
    label: t('Price'),
    symbol: Product2Symbol !== null && Product2Symbol !== void 0 ? Product2Symbol : '',
    validate: isConditionalPricefieldDisabled ? undefined : [greaterThanZero],
    decimalPlaces: valueDP,
    layout: fieldLayout,
    disabled: isConditionalPricefieldDisabled
    //onFocus={() => onChange('anchoredField', 'price')}
  }), /*#__PURE__*/_react["default"].createElement(_APReactSelect["default"], {
    name: "priceOrderType",
    customClass: "suffix-select",
    isSearchable: false,
    valueAsObject: false,
    options: [{
      value: 'Market',
      label: t('Market')
    }, {
      value: 'Limit',
      label: t('Limit')
    }]
  }))), /*#__PURE__*/_react["default"].createElement(_FormItem.RFormInputItem, {
    component: _NumberInput.MoneyInputWithSlots,
    prefix: /*#__PURE__*/_react["default"].createElement(_APReactSelect["default"], {
      name: "orderByProduct",
      customClass: "prefix-select",
      isSearchable: false,
      valueAsObject: false,
      options: [{
        value: Product1Symbol,
        label: Product1Symbol
      }, {
        value: Product2Symbol,
        label: Product2Symbol
      }],
      onSelect: handleOrderByProductChange
    }),
    name: 'quantity',
    size: "small",
    placeholder: "0",
    className: futuresOrderEntryClasses('amount-label-input'),
    label: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", null, t('Amount')), /*#__PURE__*/_react["default"].createElement("span", null, "\u2248 ", value, " ", orderByProduct === Product1Symbol ? Product2Symbol : Product1Symbol)),
    validate: [orderByProduct === Product1Symbol ? futuresGreaterThanOrEqualToValue(minimumQuantity) : futuresP1MinimumAmountValidator(minimumQuantity), validateMaxQuantity],
    decimalPlaces: orderByProduct === Product1Symbol ? quantityDP : valueDP,
    onFocus: function onFocus() {
      return onChange('anchoredField', 'quantity');
    }
  }), /*#__PURE__*/_react["default"].createElement(_reduxForm.Field, {
    name: "value",
    type: "hidden",
    component: "input"
  }), /*#__PURE__*/_react["default"].createElement(_Slider.Slider, {
    disabled: isDisabled,
    onChange: onSliderChange,
    value: sliderValue,
    breakpoints: breakpoints,
    step: "0.01"
  }), /*#__PURE__*/_react["default"].createElement(_StrategiesSelection.StrategiesSelection, {
    formName: _FuturesOrderEntryFormContainer.FUTURES_ORDER_FORM_NAME,
    timeInForceOptions: [{
      label: 'GTC',
      value: 'GTC'
    }, {
      label: 'FOK',
      value: 'FOK'
    }, {
      label: 'IOC',
      value: 'IOC'
    }]
  }), TPSL && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_FormItem.RFormInputItem, {
    component: _NumberInput.MoneyInputWithSlots,
    suffix: /*#__PURE__*/_react["default"].createElement("span", {
      className: "suffix-label"
    }, t('Last')),
    name: "takeProfit",
    size: "small",
    placeholder: "0",
    className: baseClass,
    label: t('Take Profit'),
    infoText: orderType !== _orderEntryFormConstants.futuresOrderTypes.conditional.displayName && /*#__PURE__*/_react["default"].createElement("div", null, t('Estimated Profit'), ":", ' ', /*#__PURE__*/_react["default"].createElement("span", {
      className: "estimated-amount"
    }, estimatedProfitValue, "\xA0", Product2Symbol)),
    validate: [optionalGreaterThanZero],
    symbol: Product2Symbol,
    decimalPlaces: valueDP
    //onFocus={() => onChange('anchoredField', 'takeProfit')}
  }), /*#__PURE__*/_react["default"].createElement(_FormItem.RFormInputItem, {
    component: _NumberInput.MoneyInputWithSlots,
    suffix: /*#__PURE__*/_react["default"].createElement("span", {
      className: "suffix-label"
    }, t('Last')),
    name: "stopLoss",
    size: "small",
    placeholder: "0",
    className: baseClass,
    label: t('Stop Loss'),
    infoText: orderType !== _orderEntryFormConstants.futuresOrderTypes.conditional.displayName && /*#__PURE__*/_react["default"].createElement("div", null, t('Estimated Loss'), ":", ' ', /*#__PURE__*/_react["default"].createElement("span", {
      className: "estimated-amount"
    }, estimatedLossValue, "\xA0", Product2Symbol)),
    validate: [optionalGreaterThanZero],
    symbol: Product2Symbol,
    decimalPlaces: valueDP
    //onFocus={() => onChange('anchoredField', 'input-with-suffix-select')}
  })));
};